// extracted by mini-css-extract-plugin
module.exports = {"single-price-input":"SinglePriceInput_single-price-input__3J9Tt","price-input":"SinglePriceInput_price-input__UKEFg"};